// Безопасный доступ к Telegram WebApp (barter-024, web-first).
// Скрипт telegram-web-app.js больше не грузится всегда: он подгружается
// динамически и только внутри Telegram Mini App (в hash страницы есть
// tgWebAppData/tgWebAppVersion). В обычном браузере приложение вообще не
// зависит от telegram.org, а отсутствие SDK ничего не ломает.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Twa = any;

/** Синхронное окружение Telegram (по hash, до загрузки SDK). */
export function isTelegramEnv(): boolean {
  try {
    return typeof window !== 'undefined' && /tgWebApp(Data|Version)/.test(window.location.hash);
  } catch {
    return false;
  }
}

/** Готовый WebApp или null (вне Telegram / SDK ещё не загружен). */
export function twa(): Twa | null {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const app = (window as any)?.Telegram?.WebApp;
    return app && typeof app === 'object' ? app : null;
  } catch {
    return null;
  }
}

let twaPromise: Promise<Twa | null> | null = null;

/**
 * Подгружает SDK внутри Telegram (один раз) и резолвится готовым WebApp.
 * Вне Telegram или при ошибке сети — null: это нормальный веб-режим, не сбой.
 */
export function loadTwa(): Promise<Twa | null> {
  if (twaPromise) return twaPromise;
  twaPromise = (async () => {
    if (twa()) return twa();
    if (!isTelegramEnv() || typeof document === 'undefined') return null;
    try {
      await new Promise<void>((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://telegram.org/js/telegram-web-app.js';
        script.onload = () => resolve();
        script.onerror = () => reject(new Error('telegram-web-app.js failed to load'));
        document.head.appendChild(script);
        window.setTimeout(() => reject(new Error('telegram-web-app.js timeout')), 10_000);
      });
    } catch {
      return null;
    }
    return twa();
  })();
  return twaPromise;
}
